





















































































































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import MyNav from '@/components/nav/BackNav.vue'; // nav
import Test from '@/servers/modules/vocabulary/test'; // server
import {
  Button,
  Message,
  Scrollbar,
  Card,
  Radio,
  RadioGroup,
  Input,
  Loading,
} from 'element-ui';
import MyDialog from '@/components/dialog/Index.vue'; // dialog
import moment from 'moment';
import { isOpenAnswer, OnGetOS, handleClickToAppfuncation } from '@/plugins/util'

Component.registerHooks([
  'beforeRouteEnter',
]);
@Component({
  components: {
    MyNav,
    Button,
    Scrollbar,
    Card,
    Radio,
    RadioGroup,
    Input,
    MyDialog,
  },
})
export default class extends Vue {
  private isOpenAnswer: boolean = isOpenAnswer()

  private isShowTip: boolean = false;

  // @ts-ignore
  @Mutation public openDialog:any;

  private navData: any;

  // @ts-ignore
  @Getter public skeleton: any;

  // @ts-ignore
  @Mutation public setSkeletonDescribe: any;

  // @ts-ignore
  @Mutation public closeDialog:any;

  // 什么类型的数据
  private testPaperType: string = '';

  private showPaperType: string = 'readChoose';

  private check: string = 'all';

  private remain: number = 0;

  private examinationTimer: any = '';

  private timeLeft: any = '10:00';

  private assignment: string = '';

  private questotal: number = 0;

  private testBox: any = {
    dictationList: undefined,
    listenList: undefined,
    meansList: undefined,
    info: undefined,
  };

  private fromPath: any = ''

  beforeRouteEnter(to:any, from:any, next:any) {
    next((vm:any) => {
      // 通过 `vm` 访问组件实例,将值传入fromPath
      vm.fromPath = from.path;
    });
  }

  private back() {
    if (this.fromPath == '/vocabulary/study') {
      this.$router.push('/vocabulary');
    } else {
      this.$router.go(-1);
    }
  }

  public CurrentAnswer(data: any) {
    if (data.isUnsureMarking) {
      // 标记题+1
      data.isUnsureMarking = 0;
    } else {
      data.isUnsureMarking = 1;
      const img = require('@/assets/images/ui-word/word-study-bear.png');
      const html = `<div style="width: 273px;height: 228px;background: rgba(32, 32, 32, 0.7);border-radius: 30px;"><img src="${img}" style="width: 108px;height: 80px;position: absolute;left:84px;top:60px"/><span style="position: absolute;width: 100%;left: 10px;font-size: 20px;bottom: 54px;">标记疑问题目成功！</span></div>`;
      (window as any).$alert(html, 1000, { background: 'transparent' });
      // 标记题+1
    }
  }

  private finallyFill: any = {
    dictationList: 0,
    listenList: 0,
    meansList: 0,
  };

  // 计算已填写题目
  private fillProblemSum(opera:any) {
    if (opera == 'reduce') {
      this.remain--;
    } else {
      this.remain++;
      if (this.remain > this.questotal) this.remain = this.questotal;
    }
    // 不需要存储 每一次填写需要将填写后的数据进行保存
  }

  // 播放音频
  private playAudio(audio:any, item:any) {
    item.togglePlayModel = true;
    setTimeout(() => {
      item.togglePlayModel = false;
    }, 1000);
    // 触发停止播放的方法

    let isapp = localStorage.getItem('isapp') 
    let os = OnGetOS()

    if (isapp == 'android') {
      handleClickToAppfuncation('playSound',audio)
    }else {
      if (os == 'iphone') {
        this.$refs.audio.src = audio; 
        this.$nextTick(() => {
          this.$refs.audio.load()   
          this.$refs.audio.play();
        })
      }else {
        this.$refs.audio.src = audio; 
        this.$refs.audio.play();
      }           
    }
  }

  private isFirst(index:number) {
    if (index == 1 || (index != 1 && (index - 3) % 3 == 1)) {
      return 'is-first';
    }
    return '';
  }

  private barGoTop() {
    const _this = this;
    function goToTop() {
      setTimeout(() => {
        let index = 0;
        if (_this.showPaperType == 'readChoose') {
          index = 0;
        } else if (_this.showPaperType == 'listenChoose') {
          index = 1;
        } else if (_this.showPaperType == 'listenWhite') {
          index = 2;
        }
        const container = _this.$el.querySelectorAll('.el-scrollbar__wrap')[
          index
        ];

        if (container.scrollTop > 0) {
          container.scrollTop -= 50;
          goToTop();
        } else {
          container.scrollTop = 0;
        }
      }, 1);
    }
    goToTop();
  }

  // private audioLoad(e) {
  //   // 加载 方法

  //   // 播放音频
  //   this.$refs.audio.onplay();
  // }

  // 提交试卷
  private submitAssignment(time:any) {

    const _this = this;
    // 提交试卷时 清空所有存在的数据
    this.finallyFill = {
      dictationList: 0,
      listenList: 0,
      meansList: 0,
    };
    noFill(this.testBox.meansList, 'meansList');
    noFill(this.testBox.listenList, 'listenList');
    noFill(this.testBox.dictationList, 'dictationList');
    function noFill(data, name) {
      try {
        for (let i = 0; i < data.length; i++) {
          if (data[i].userAnswer == null) {
            _this.finallyFill[name] = Number(_this.finallyFill[name]) + 1;
          }
        }
      } catch (e) {}
    }
    const noFillList = [];
    if (this.finallyFill.dictationList) {
      noFillList.push(
        `<span class="blastingenglish-orange">${this.finallyFill.dictationList}道</span>听写题`,
      );
    }
    if (this.finallyFill.listenList) {
      noFillList.push(
        `<span class="blastingenglish-orange">${this.finallyFill.listenList}道</span>听辨题`,
      );
    }
    if (this.finallyFill.meansList) {
      noFillList.push(
        `<span class="blastingenglish-orange">${this.finallyFill.meansList}道</span>释义题`,
      );
    }

    if (window.LS.get('BlastingEnglish_test_query')) {
      const Show = window.LS.get('BlastingEnglish_test_query');

      if (Show.showPaperType) {
        this.showPaperType = Show.showPaperType;
      }

    }
    // 当有时间传入进来时 表示 时间截止 关闭弹窗
    if (time == 'time') {
      this.closeDialog();
      this.dialogHandle(1);
    }
    // 全部填写完毕了 并且倒计时不为 00:00 时表明提前交卷
    else if (noFillList.length > 0 && this.timeLeft != '00:00') {
      this.assignment = `您还有${noFillList.join(
        '、',
      )}没有完成，确认要交卷吗？`;
      this.openDialog({
        visible: true,
        titleClose: true,
        titleIcon: false,
        text: '确认交卷',
        footer: [
          {
            class: 'button-style-border',
            word: '取消',
          },
          {
            class: 'button-style-background',
            word: '确认',
          },
        ],
      });
    }
    // 表示全部填写完毕
    else if (noFillList.length <= 0) {
      this.dialogHandle(1);
    }
  }

  private async dialogHandle(index:number) {
    if (index === 0) {
      this.closeDialog();
    }
    // 交卷子
    else if (index === 1) {
      // 提交试卷后清空定时器
      clearInterval(this.examinationTimer);
      // 等待对接 提交试卷的接口
      this.closeDialog();
      const paper = Loading.service({ text: '交卷中' });
      this.testBox.info.dictationList = this.testBox.dictationList;
      this.testBox.info.listenList = this.testBox.listenList;
      this.testBox.info.meansList = this.testBox.meansList;
      this.testBox.info.testTime = Number(
        `${new Date()
          .getTime()
          .toString()
          .substr(0, 9)}0999`,
      );
      const res = await Test.saveStudentTestResult(this.testBox.info);
      window.LS.remove('BlastingEnglish_test_query');
      paper.close();

      // 判断是否通过后测，若通过，则可以触发总复习提示
      if (this.testPaperType == '4') {
        if (res.data.code == 0) {
          if (res.data.data.testPaperState == 2) {
            this.isShowTip = true;
          }
        }
      }
      // this.$router.go(-1);
      if (!res.data.code) {
        Message('提交成功');


        if (
          res.data.data
          && res.data.data.article
          && res.data.data.article.length
        ) {
          let articleTitle = ''
          res.data.data.article.forEach((item:any) => {
            articleTitle = articleTitle + item.title +'、'
          });
          articleTitle = articleTitle.slice(0,articleTitle.length-1)
          // 跳转文章提示页
          this.$router.push({
            path: '/vocabulary/prompt',
            query: {
              type: 'article',
              articleTitle: articleTitle,
              articleUserCourseId: res.data.data.articleUserCourseId
            },
          });
          return false;
        }
        if (
          res.data.data
          && res.data.data.gameList
          && res.data.data.gameList.length
        ) {
          let gameName = ''
          res.data.data.gameList.forEach((item:any) => {
            gameName = gameName + item.name +'、'
          });
          gameName = gameName.slice(0,gameName.length-1)
          // 跳转游戏提示页
          this.$router.push({
            path: '/vocabulary/prompt',
            query: {
              type: 'game',
              gameName: gameName
            },
          });
          return false;
        }
        // return
        // 提交 试卷 并获取答题详情
        this.testDetails(this.testBox.info.testId);
        // this.$router.go(-1);
      } else {
        Message('提交失败');
        // 重新再次提交
        await this.dialogHandle(1);
      }
    }
  }

  private created() {
    this.$nextTick(() => {

    });
    this.navData = window.LS.get('basicData').courseName;
    this.setSkeletonDescribe(true);
    this.closeDialog();
    NProgress.start();
    this.getStudyList();
  }

  private changeNow(data: any, item: any) {

    if (!data.answer) {
      this.fillProblemSum('reduce');
    }
    data.answer = item;
  }

  private changeInput(data: any, item: any) {
    // 去除单词前后空格
    item = item.trim();
    data.userAnswer = data.userAnswer.trim();
    if (item.length > 20) {
      item = item.substring(0, 20);

    }
    if (!data.answer && item) {
      this.fillProblemSum('reduce');
    }
    // 左右去空后
    if (item == '') {
      // 将已填写置为空
      data.answer = undefined;
      this.fillProblemSum('add');
    }
    data.answer = item || '';
  }

  // 通过学生编号和课程编号查询试卷题目详情
  private startTime: any = moment();

  private endTime: any = '';

  private get countDown() {
    return () => {
      const m1: any = this.startTime;
      const m2: any = this.endTime;
      const du = moment.duration(m2 - m1, 'ms');
      const mins = du.get('minutes');
      const ss = du.get('seconds');
      if (mins <= 0 && ss <= 0) {
        this.submitAssignment('time');
        return '00:00';
      }
      return `${this.PrefixInteger(mins, 2)}:${this.PrefixInteger(ss, 2)}`;
    };
  }

  private PrefixInteger(num: any, n: any) {
    return (Array(n).join('0') + num).slice(-n);
  }

  private async getStudyList() {
    // alert(1)
    // 判断是否是 查看试卷详情内容
    if (this.$route.query.testId) {
      this.testDetails(this.$route.query.testId);
      return false;
    }
    // 设置结束时间 及 拿到测试相关的类型
    const test_query = window.LS.get('BlastingEnglish_test_query');
    // 已提交并刷新页面
    if (!test_query) {
      this.$router.go(-1);
      return false;
    }
    const paper = Loading.service({ text: '生成试卷中' });
    this.testPaperType = test_query.testPaperType;
    // 自定义结束时间
    this.endTime = moment().add(test_query.time, 'minutes');
    const data = {
      courseId: window.LS.get('vteData').course.courseId,
      userCourseId: window.LS.get('vteData').userCourseId,
      userId: window.LS.get('vteData').user.userId,
      testPaperType: this.testPaperType,
    };
    const res = await Test.getByStudentCourseId(data).catch((e) => {


      NProgress.done();

      paper.close();
      this.$router.go(-1);
    });

    if (window.LS.get('BlastingEnglish_test_query')) {
      const Show = window.LS.get('BlastingEnglish_test_query');

      if (Show.showPaperType) {
        this.showPaperType = Show.showPaperType;
      }

    }
    NProgress.done();
    this.setSkeletonDescribe(true);
    const list = res.data.data;
    // 释义题
    // list.meansList
    // 听辨题
    // list.listenList
    // 听写题
    // list.dictationList
    const _this = this;
    _this.questotal = 0;
    this.testBox.info = list;
    if (list.dictationList) {
      this.testBox.dictationList = addLabel(list.dictationList);
    }
    if (list.listenList) {
      this.testBox.listenList = addLabel(list.listenList);
    }
    if (list.meansList) {
      this.testBox.meansList = addLabel(list.meansList);
    }


    function addLabel(data: any) {
      for (let i = 0; i < data.length; i++) {
        // 增加以问题标记 按钮 默认是没有添加标记
        data[i].isUnsureMarking = 0;
        data[i].label = '';
        data[i].togglePlayModel = false;
      }
      _this.questotal += data.length;
      return data;
    }
    this.remain = this.questotal;
    // 开启定时器 - 倒计时
    this.examinationTimer = setInterval(() => {
      this.timeLeft = this.countDown();
      this.startTime = moment();
    }, 1000);
    paper.close();
  }

  // 筛选题目
  private async filterTopics(text: any) {
    this.check = text;
  }

  private isFilter(item: any) {
    if (this.check != 'all') {
      if (this.check == 'chose' && !item.answer) {
        return 'none-show';
      }
      if (this.check == 'none' && item.answer) {
        return 'none-show';
      }
      // 是否已经成为标记题
      if (this.check == 'marking' && !item.isUnsureMarking) {
        return 'none-show';
      }
    } else {
      return '';
    }
  }

  private beforeDestroy() {
    clearInterval(this.examinationTimer);
  }

  // 获取详情的内容
  private async testDetails(testId: any) {
    const param: any = {
      testId,
      isShowTip: this.isShowTip,
    };
    // 如果前侧标记存在 添加前侧标记
    if (this.$route.query.scourMark) {
      param.scourMark = this.$route.query.scourMark;
    }
    this.$router.replace({ path: '/vocabulary/testDetail', query: param });
  }
}
